import { defineMessages } from 'react-intl';

type MessageKeys = 'expandButton' | 'openSettingsButton' | 'betaLabel';

const messages: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		expandButton: {
			id: 'rovo-platform-ui-components.store-memory-update.expandButton',
			defaultMessage: 'Memory updated',
			description: 'Label for button to expand and review user memory',
		},
		openSettingsButton: {
			id: 'rovo-platform-ui-components.store-memory-update.openSettingsButton',
			defaultMessage: 'Manage memories',
			description: 'Label for button to open memory management modal',
		},
		betaLabel: {
			id: 'rovo-platform-ui-components.store-memory-update.betaLabel',
			defaultMessage: 'BETA',
			description: 'Beta lozenge label shown beside the Memory updated inline message',
		},
	});

export default messages;
